module.exports = __webpack_public_path__ + "img/video-icon.3073258b.svg";